import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { copyToClipboard, shareFB, shareVK } from './share';
import { ToastService } from '../toast/toast.service';
import { LocalizationService } from '../localization/localization.service';
import shareLocalization from './share.localization';

@Component({
  selector: 'mtg-share',
  templateUrl: './share.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareComponent {
  @Input()
  url: string;
  @Input()
  variant: 'icon' | 'button' = 'icon';

  localization = shareLocalization[this.localizationService.getLocale()];

  constructor(
    private toastService: ToastService,
    private localizationService: LocalizationService,
  ) {
  }

  shareVk(): void {
    shareVK(this.url);
  }

  shareFb(): void {
    shareFB(this.url);
  }

  copyLink(): void {
    copyToClipboard(this.url);
    this.toastService.success(this.localization.linkCopied);
  }
}
